export default "__VITE_ASSET__bK912JKc__"